import {
    CANVAS_QUIZ_META_FAILURE,
    CANVAS_QUIZ_META_REQUEST,
    CANVAS_QUIZ_META_SUCCESS,
} from './canvasQuizTypes'

const initialState = {
    loading: false,
    loadingMessage: '',
    fetchSuccess: false,
    quizData: [],
    message: '',
    error: '',
}

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CANVAS_QUIZ_META_REQUEST:
            return {
                ...state,
                loading: true,
                loadingMessage: 'Fetching quiz data...',
                fetchSuccess: false,
                quizData: {},
                message: '',
                error: '',
            }
        case CANVAS_QUIZ_META_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: true,
                quizData: action.payload,
                message: '',
                error: '',
            }
        case CANVAS_QUIZ_META_FAILURE:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: false,
                quizData: {},
                message: '',
                error: action.payload,
            }

        default:
            return state
    }
}

export default reducer
